<template>
  <div id="zone-post-code" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <v-col cols="12">
        <h2 class="ma-0 text-center">{{ $route.meta.title }}</h2>
      </v-col>

      <v-col cols="12" class="mt-2 mt-md-4 mb-8">
        <v-card class="p-content-cards mx-auto rounded-lg px-8 pt-4 pb-md-0">
          <v-row no-gutters>
            <v-col cols="12">
              <p class="g-bold g-heading-s text-center">
                Lookup zone by postcode
              </p>
            </v-col>

            <i-search-post-code
              dense
              class="mt-4 mt-md-6 mb-n3"
              :allow-export-all="false"
            />

            <v-col v-if="!pdfURLError" cols="12">
              <div class="text-center py-5">
                <v-btn
                  class="i-text-link"
                  :href="postCodeZonesPDFURL"
                  target="_blank"
                  text
                >
                  <span v-if="$vuetifyDisplay.smAndUp"
                    >Click here to view all zones per postcode</span
                  >
                  <span v-else
                    >Click here to view <br />all zones per postcode</span
                  >
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getPostCodeZonesPDF } from '@/services/dataMaintenance'
import iSearchPostCode from '@/components/SearchPostCode'

export default {
  components: {
    iSearchPostCode
  },

  data() {
    return {
      postCodeZonesPDFURL: '',
      pdfURLError: false
    }
  },

  methods: {
    getZonesPDF() {
      getPostCodeZonesPDF()
        .then((response) => {
          this.postCodeZonesPDFURL = response.url
          this.pdfURLError = false
        })
        .catch(() => {
          this.pdfURLError = true
        })
    }
  },

  mounted() {
    this.getZonesPDF()
  }
}
</script>

<style lang="scss" scoped>
#zone-post-code {
  .p-content-cards {
    max-width: 740px !important;
    margin: auto;
  }
}
</style>
